import type { Order } from "@jti/magento";
import type { MagentoApiGetCustomerOrderQueryResponse } from "@jti/magento-api-v2";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";
import { mapCustomerOrderResponse } from "../utils/mapCustomerOrderResponse";

export const getCustomerOrderEndpoint = (builder: MagentoApiBuilder) => ({
  getCustomerOrder: builder.query<Order, string>({
    query: (orderNumber) => ({
      method: "getCustomerOrder",
      params: [{ orderNumber }],
    }),
    transformResponse: (response: MagentoApiGetCustomerOrderQueryResponse) => mapCustomerOrderResponse(response),
    providesTags: [TAGS.ORDER],
  }),
});
